/**
 * Safely parse a date string for **display** purposes.
 *
 * JavaScript's `new Date("2026-05-05")` treats date-only strings as UTC
 * midnight, which in US timezones (UTC-5 / UTC-6 etc.) rolls back to the
 * previous calendar day.  By appending `T12:00:00` we shift to noon UTC,
 * which stays on the correct calendar day in every US timezone.
 */
export function parseLocalDate(dateStr: string | undefined | null): Date {
  if (!dateStr) return new Date();
  // If the string already contains a time component, use it as-is
  if (dateStr.includes('T') && dateStr.length > 11) {
    return new Date(dateStr);
  }
  // Date-only string — anchor to noon to avoid timezone day-shift
  const datePart = dateStr.split('T')[0];
  return new Date(`${datePart}T12:00:00`);
}
